import { Badge, Box, HStack, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { FiTarget } from "react-icons/fi";

interface PlatformSelectionProps {
  platform: string;
  onChange: (platform: string) => void;
  disabled?: boolean;
}

const platformOptions = [
  { value: "", label: "Select Platform" },
  { value: "Google Ads", label: "Google Ads" },
  { value: "YouTube Ads", label: "YouTube Ads" },
  { value: "Facebook Ads", label: "Facebook Ads" },
  { value: "Instagram Ads", label: "Instagram Ads" },
  { value: "TikTok Ads", label: "TikTok Ads" },
  { value: "Snapchat Ads", label: "Snapchat Ads" },
  { value: "LinkedIn Ads", label: "LinkedIn Ads" },
  { value: "X Ads (Twitter)", label: "X Ads (Twitter)" },
  { value: "Pinterest Ads", label: "Pinterest Ads" },
  { value: "Amazon Ads", label: "Amazon Ads" },
  { value: "Microsoft Ads", label: "Microsoft Ads (Bing)" },
  { value: "Reddit Ads", label: "Reddit Ads" },
  { value: "Custom", label: "Custom" },
  { value: "Other", label: "Other" }
];

export const PlatformSelection: React.FC<PlatformSelectionProps> = ({
  platform,
  onChange,
  disabled = false
}) => {
  return (
    <Box bg="white" shadow="sm" rounded="lg" p={6}>
      <HStack mb={4}>
        <Icon as={FiTarget} color="blue.500" boxSize={5} />
        <Text fontWeight="semibold" fontSize="lg">
          Select Platform
        </Text>
        <Badge colorScheme="red" size="sm">
          Required
        </Badge>
      </HStack>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Advertising Platform
        </Text>
        <select
          value={platform}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          required
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #CBD5E0",
            backgroundColor: "white"
          }}
        >
          {platformOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <Text fontSize="sm" color="gray.500" mt={2}>
          Choose the platform where this link will be used
        </Text>
      </Box>
    </Box>
  );
};
